module.exports = __webpack_public_path__ + "static/media/sa.8830dfa4.svg";